export default {
    data: () => ({
        translations: {
            title: {
                el: "Λήξη Πόντων",
                en: "Point Expiration",
                it: "Scadenza dei punti"
            },
            description1: {
                el: "Μηδενισμός πόντων μετά από ",
                en: 'Nullification of points after ',
                it: "Azzeramento dei punti dopo "
            },
            description2: {
                el: " ανενεργές ημέρες του χρήστη.",
                en: " inactive days of the user.",
                it: " giorni di inattività dell'utente."
            },
            numberOfDays: {
                el: "Ημέρες",
                en: "Days",
                it: "Giorni"
            },
            type0forInfinite: {
                el: "Για να μην υπάρχει λήξη, εισάγετε 0",
                en: "For no expiration, type 0 ",
                it: "Per non avere scadenze, digitare 0 "
            },
            neverExpire: {
                el: "Οι πόντοι δεν λήγουν <b>ποτέ</b>.",
                en: "The points will <b>never</b> expire.",
                it: "I punti non scadranno <b>mai</b>."
            },
        }
    })
};
